// This account's published setlists, for the Playlists index (#372) — a
// non-component module so fast-refresh lint stays clean. Disabled (not a
// tutor, signed out) it fetches nothing and answers empty.

import { useCallback, useEffect, useState } from 'react';
import { listOwnShares, type OwnShare } from '@/data/sharedSetlists';

export function useOwnShares(enabled: boolean): {
  shares: OwnShare[];
  error: string | null;
  /** Drop one share from the local view after a successful unshare. */
  removeLocal: (shareId: string) => void;
} {
  const [shares, setShares] = useState<OwnShare[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    listOwnShares().then(
      (rows) => {
        if (!cancelled) {
          setShares(rows);
          setError(null);
        }
      },
      (e) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Could not load shares.');
      },
    );
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const removeLocal = useCallback(
    (shareId: string) => setShares((prev) => prev.filter((s) => s.shareId !== shareId)),
    [],
  );

  return { shares, error, removeLocal };
}
